import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-help-desk',
  templateUrl: './help-desk.component.html',
  styleUrls: ['./help-desk.component.scss']
})
export class HelpDeskComponent implements OnInit {

  video_URL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ACCEPT_ASSIGN_ORDER);
  // video_URL_OWN_FLEET;
  displaytext = 'How to accept and assign the order';
  arr = [
    {
      'name': 'How to accept and assign the order', 'url': environment.ACCEPT_ASSIGN_ORDER,
    },
    {
      'name': 'How to Accept and Assign loads in Load dashboard', 'url': environment.ACCEPTASSIGNLOADDASHBOARD,
    },
    {
      'name': 'How to add an own fleet driver', 'url': environment.ADDING_OWN_DRIVER,
    },
    {
      'name': 'How to attach a vehicle to driver', 'url': environment.ATTACH_VEHICLE,
    },
    {
      'name': 'How to detach a vehicle from a driver', 'url': environment.DETACH_VEHICLE,
    },
    {
      'name': 'How to raise the carrier invoice ', 'url': environment.RAISE_CARRIER_INVOICE,
    },
    {
      'name': 'How to add an own vehicle', 'url': environment.ADDING_VEHICLE,
    },
    {
      'name': 'How to reassignment of shipment ', 'url': environment.REASSIGNMENT_SHIPMENT,
    },
    {
      'name': 'How to generate invoice with HSN code', 'url': environment.GENERATE_INVOICE_HSN_CODE,
    },
    {
      'name': 'How to add a spot driver', 'url': environment.ADDING_SPOT_DRIVER,
    },
    {
      'name': 'How to add an User to an Unit', 'url': environment.ADD_USER_IN_CARRIER,
    },
    {
      'name': 'How to add an Unit to your account', 'url': environment.ADD_UNIT_IN_CARRIER,
    },
    {
      'name': 'How to view outstanding EPODs and mark the Shipments as complete', 'url': environment.OUTSTANDING_EPOD,
    },
    {
      'name': 'How to add GPS providers in Unit settings', 'url': environment.ADDING_GPS,
    },
    {
      'name': 'How to create an invoice for pending shipments', 'url': environment.INVOICE_PENDING_SHIPMENTS,
    },
    {
      'name': 'How to add received quantity', 'url': environment.ADD_RECEIVED_QUANTITY,
    },
    {
      'name': 'How to create invoice', 'url': environment.CREATE_INVOICE,
    },
    {
      'name': 'How to split invoices', 'url': environment.SPLITINVOICE,
    },
    {
      'name': 'How to Request MWG-A', 'url': environment.REQUESTMWG,
    },
    {
      'name': 'How to check MWG-A status', 'url': environment.MWG_STATUS,
    }
  ]
  searchVideo;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }
  videochange(item) {
    this.video_URL = this.sanitizer.bypassSecurityTrustResourceUrl(item.url);
    this.displaytext = item.name;
  }
}
